import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Sliders = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M9.303 2.5a2.917 2.917 0 0 0-5.272 0H2.5a1.25 1.25 0 1 0 0 2.5h1.53a2.917 2.917 0 0 0 5.273 0H17.5a1.25 1.25 0 0 0 0-2.5zM7.917 3.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-5.417 5h8.197a2.917 2.917 0 0 1 5.272 0H17.5a1.25 1.25 0 0 1 0 2.5h-1.53a2.917 2.917 0 0 1-5.273 0H2.5a1.25 1.25 0 0 1 0-2.5m10.833 2.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m-6.666 2.917c1.163 0 2.168.681 2.636 1.666H17.5a1.25 1.25 0 0 1 0 2.5H9.303a2.917 2.917 0 0 1-5.272 0H2.5a1.25 1.25 0 0 1 0-2.5h1.53a2.92 2.92 0 0 1 2.637-1.666m0 4.166a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5" }) }));
});
Sliders.displayName = 'Sliders';
Sliders.__iconComponentType = 'standard';
export default Sliders;
//# sourceMappingURL=Sliders.js.map